import React from 'react';
import { Box, styled } from '@mui/material';
import { useCowbellTranslations } from '../../i18n/translations';

type Props = {
  aggregateLabel?: string;
};

const VerticalCFRangeGraphLegend: React.FC<Props> = ({
  aggregateLabel = 'Company CF',
}) => {
  const { t } = useCowbellTranslations();
  return (
    <LegendContainer>
      <AggregateContainer>
        <IndustryCFFTriangle blue />
        Industry CF
      </AggregateContainer>
      <AggregateContainer>
        <IndustryAverageTriangle green />
        Company CF &ge; Industry CF
      </AggregateContainer>
      <AggregateContainer>
        <IndustryAverageTriangle />
        Company CF &lt; Industry CF
      </AggregateContainer>
    </LegendContainer>
  );
};

export default VerticalCFRangeGraphLegend;

const LegendContainer = styled(Box)(() => {
  return {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    fontWeight: 500,
    fontSize: '10px',
  };
});

const AggregateContainer = styled(Box)(() => {
  return {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  };
});

const TriangleBase = styled(Box)({
  width: 0,
  height: 0,
  display: 'inline-block',
  borderTop: '7px solid transparent',
  borderBottom: '7px solid transparent',
});

const IndustryAverageTriangle = styled<any>(TriangleBase)(
  ({ theme, green }) => {
    return {
      right: '-100%',
      borderRight: `7px solid ${
        green ? theme.config.colors.cowbellAccent : theme.config.colors.textRed
      }`,
      borderLeft: '7px solid transparent',
    };
  }
);

const IndustryCFFTriangle = styled<any>(TriangleBase)(({ theme, blue }) => {
  return {
    borderLeft: `7px solid ${
      blue ? theme.config.colors.cowbellBlue : theme.config.colors.textRed
    }`,
    borderRight: '7px solid transparent',
    transform: 'rotate(180deg)',
  };
});
